import { Order_By } from "@/api/hasura/generated/graphql"
import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
import { SearchArgs } from "@/services/admin/AccountSyncService"
import {
  AccountSyncTableFilters,
  syncAccountTableFilters,
} from "@/views/admin/syncAccounts/components/syncAccountConfig"
import { defineStore } from "pinia"

interface SyncedAccountsState {
  tableOptions: SoDataTableOptions<AccountSyncTableFilters>
  searchArgs: SearchArgs
}

const getDefaultOptions = (): SoDataTableOptions<AccountSyncTableFilters> => ({
  search: "",
  page: 1,
  pageSize: 10,
  filters: syncAccountTableFilters,
  orderBy: { createdDttm: Order_By.Desc },
})

export const useSyncedAccountsStore = defineStore("syncedAccounts", {
  state: (): SyncedAccountsState => ({
    tableOptions: getDefaultOptions(),
    searchArgs: {
      searchTerm: "ACCOUNT_NUMBER",
      showSyncedAccounts: false,
      ...getDefaultOptions(),
    },
  }),
})
